module.exports = __webpack_public_path__ + "img/about.add73d0f.jpg";